import CTNDropdown from '@ctn/ui/components/ctn-dropdown';
import CTNInput from '@ctn/ui/components/ctn-input';
import classNames from 'classnames';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import useOptionsStore from '@/store/options.store';

import { TIPO_DOCUMENTO_IDENT } from '@/constants/tramite.constants';

import { type SujetoForm } from '../config';

type Props = {
	readonly className?: string;
	readonly title?: string;
	readonly isDisplay?: boolean;
	readonly isDisabled?: boolean;
};
const DatosPersona = ({ className, title, isDisplay, isDisabled }: Props) => {
	const {
		control,
		formState: { errors, dirtyFields },
		trigger,
		setValue,
		watch,
	} = useFormContext<SujetoForm>();

	const paises = useOptionsStore((state) => state.options.paises) ?? [];
	const tipoDocumentoIdent = useOptionsStore((state) => state.options.tramite?.tipoDocumentoIdent) ?? [];

	const classNameDatosJuridica = useMemo(() => classNames(className), [className]);

	useEffect(() => {
		if (!watch('idTipoDocumentoIdent')) {
			setValue('idTipoDocumentoIdent', String(TIPO_DOCUMENTO_IDENT.NIF));
		}
	}, []);

	return (
		<fieldset className={classNameDatosJuridica}>
			{title && <legend className="c-pnp-heading-h4">{title}</legend>}
			<div
				className={classNames({
					['[ c-pnp-form-group ] [ u-flow ]']: isDisplay,
					['[ u-mt-16 ]']: title,
				})}
			>
				<div className="c-pnp-flow-grid">
					<CTNDropdown
						filter
						required={!isDisplay}
						displayOnly={isDisplay}
						condensed={isDisplay}
						noFeedBack={isDisplay}
						disabled={isDisabled}
						options={paises}
						classNameField="c-pnp-flow-grid__nac"
						name="nacionalidad"
						label="Nacionalidad"
						control={control}
						appendTo='body'
						error={errors.nacionalidad?.message}
					/>
					<CTNDropdown
						disabled
						required={!isDisplay}
						displayOnly={isDisplay}
						condensed={isDisplay}
						noFeedBack={isDisplay}
						options={tipoDocumentoIdent}
						classNameField="c-pnp-flow-grid__doc"
						name="idTipoDocumentoIdent"
						label="Tipo de documento"
						control={control}
						appendTo='body'
						error={errors.idTipoDocumentoIdent?.message}
						onChange={() => {
							if (dirtyFields.numeroDocumento) {
								trigger('numeroDocumento');
							}
						}}
					/>
					<CTNInput
						required={!isDisplay}
						displayOnly={isDisplay}
						condensed={isDisplay}
						noFeedBack={isDisplay}
						disabled={isDisabled}
						type="text"
						classNameField="c-pnp-flow-grid__numdoc"
						name="numeroDocumento"
						label="Número de documento"
						control={control}
						error={errors.numeroDocumento?.message}
					/>
				</div>
				<div className="c-pnp-flow-grid">
					<CTNInput
						required={!isDisplay}
						displayOnly={isDisplay}
						condensed={isDisplay}
						noFeedBack={isDisplay}
						disabled={isDisabled}
						type="text"
						classNameField="c-pnp-flow-grid__full"
						name="apellido1RacSoc"
						label="Razón social"
						control={control}
						maxLength={100}
						error={errors.apellido1RacSoc?.message}
					/>
				</div>
			</div>
		</fieldset>
	);
};

export default DatosPersona;
